/**
 * @generated SignedSource<<63730bb8793c1ba528f3e41291d00b8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteSession_DeleteSessionMutation$variables = Record<PropertyKey, never>;
export type DeleteSession_DeleteSessionMutation$data = {
  readonly deleteSession: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly session: {
      readonly loggedOut: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type DeleteSession_DeleteSessionMutation = {
  response: DeleteSession_DeleteSessionMutation$data;
  variables: DeleteSession_DeleteSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "loggedOut",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteSession_DeleteSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeleteSessionMutationPayload",
        "kind": "LinkedField",
        "name": "deleteSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DeleteSession_DeleteSessionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeleteSessionMutationPayload",
        "kind": "LinkedField",
        "name": "deleteSession",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Session",
            "kind": "LinkedField",
            "name": "session",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "07a7d091f1d5b9d89123eab50bd11683",
    "id": null,
    "metadata": {},
    "name": "DeleteSession_DeleteSessionMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteSession_DeleteSessionMutation {\n  deleteSession {\n    session {\n      loggedOut\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "002538a643ecdf652a74bb30a1dc51ce";

export default node;
